import { ApiFunc, getInstance } from '@src/helpers/httpClient'

import * as API from '../constants/api'

const instance = getInstance()

export const paymentsPrincipal: ApiFunc<`${typeof API.STUDENT_PAYMENTS_PRINCIPAL}`, 'get'> = data =>
  instance.get(API.STUDENT_PAYMENTS_PRINCIPAL, {
    params: data,
  })

export const paymentsByStudent: ApiFunc<`${typeof API.STUDENT_PAYMENTS_BY_STUDENT}`, 'get'> = data =>
  instance.get(API.STUDENT_PAYMENTS_BY_STUDENT, {
    params: data,
  })

export const paymentsCreate: ApiFunc<`${typeof API.STUDENT_PAYMENTS}`, 'post'> = data =>
  instance.post(API.STUDENT_PAYMENTS, data)
